// extracted by mini-css-extract-plugin
module.exports = {"eventTitle":"ToysSoldOut_eventTitle__3INCO","contentText":"ToysSoldOut_contentText__24F3e","text":"ToysSoldOut_text__2B8L3"};